import React, { useState, useRef } from 'react'
import styled, { useTheme } from 'styled-components'
import useNavbar from './useNavbar'
import ContactUsModal from '../ContactUsModal'
import SupportCall from '../Icons/SupportCall'
import Cart from '../Icons/Cart'
import { hexToRgbA } from '../../utils/helper'
import { Tooltip } from '../Common'
import HeaderAvatar from '../Icons/HeaderAvatar'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'

const NavWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

const NavContainer = styled.div`
  max-width: 1120px;
  width: 100%;
  border-bottom: 2px solid
    ${props => hexToRgbA(props.theme.color.primaryText, 0.15)};
`

const inactiveColor = props => hexToRgbA(props.theme.color.primaryText, 0.6)

const Menu = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
`

const Section = styled.div`
  display: flex;
  gap: 24px;
  align-items: stretch;
`

const MenuItem = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: ${inactiveColor};
  cursor: pointer;
  text-decoration: none;
  padding: 10px 0 8px 0;
  border-bottom: 3px solid transparent;
  margin-bottom: -1px;

  &:hover {
    color: ${props => props.theme.color.primaryText};
  }

  &.active {
    color: ${props => props.theme.color.primaryText};
    font-weight: 600;
    border-bottom-color: ${props => props.theme.color.brand || '#2970ff'};
  }
`

const PermanentMenuItem = styled.a`
  cursor: pointer;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0 10px 0;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
  }

  svg {
    cursor: pointer;
    color: ${inactiveColor};
  }

  &.active {
    svg {
      color: ${props => props.theme.color.brand || '#2970ff'};
    }
  }
  &:hover {
    svg {
      color: ${props => props.theme.color.primaryText};
    }
  }
`

const Dweb = ({ items }) => {
  const theme = useTheme()
  const history = useHistory()
  const navbarSettings = useSelector(
    store => store.centerreducer?.regionsDetails?.client?.navbar_settings
  )

  const isProductsEnabled = navbarSettings?.find(
    item => item.slug === 'products'
  )

  const {
    selectedItemIndex,
    isLoggedIn,
    commonMenuItems,
    loginMenuItem
  } = useNavbar(items)

  const [isContactModalOpen, setContactModalOpen] = useState(false)
  const contactButtonRef = useRef(null)
  const cartButtonRef = useRef(null)
  const profileButtonRef = useRef(null)

  const renderOption = ({ index, children, slug, url }) => {
    return (
      <MenuItem
        key={slug}
        href={url}
        className={index === selectedItemIndex ? 'active' : ''}
      >
        {children}
      </MenuItem>
    )
  }

  return (
    <>
      <NavWrapper>
        <NavContainer>
          <Menu>
            <Section>
              {commonMenuItems.map(({ index, title, slug, url }) =>
                renderOption({
                  index,
                  children: <>{title}</>,
                  slug,
                  url
                })
              )}
            </Section>
            <Section style={{ gap: '4px' }}>
              <Tooltip text="Contact us" triggerRef={contactButtonRef}>
                <PermanentMenuItem
                  ref={contactButtonRef}
                  className={isContactModalOpen ? 'active' : ''}
                  onClick={() => setContactModalOpen(true)}
                >
                  <div>
                    <SupportCall
                      fill={
                        isContactModalOpen
                          ? theme.color.brand
                          : theme.color.primaryText
                      }
                    />
                  </div>
                </PermanentMenuItem>
              </Tooltip>
              {isProductsEnabled && (
                <Tooltip text="Cart" triggerRef={cartButtonRef}>
                  <PermanentMenuItem
                    ref={cartButtonRef}
                    className={
                      window.location.pathname.includes('/cart') ? 'active' : ''
                    }
                    href="/cart"
                  >
                    <div>
                      <Cart
                        fill={
                          window.location.pathname.includes('/cart')
                            ? theme.color.brand
                            : theme.color.primaryText
                        }
                      />
                    </div>
                  </PermanentMenuItem>
                </Tooltip>
              )}
              {isLoggedIn ? (
                <Tooltip text="My account" triggerRef={profileButtonRef}>
                  <PermanentMenuItem
                    ref={profileButtonRef}
                    className={
                      window.location.pathname.includes('/my-account')
                        ? 'active'
                        : ''
                    }
                    onClick={() => {
                      history.push(
                        loginMenuItem?.url ? loginMenuItem?.url : '/my-account'
                      )
                    }}
                  >
                    <div>
                      <HeaderAvatar
                        fill={
                          window.location.pathname.includes('/my-account')
                            ? theme.color.brand
                            : theme.color.primaryText
                        }
                      />
                    </div>
                  </PermanentMenuItem>
                </Tooltip>
              ) : (
                renderOption({
                  index: loginMenuItem?.index,
                  children: <>{loginMenuItem?.title}</>,
                  slug: loginMenuItem?.slug,
                  url: loginMenuItem?.url || '/my-account'
                })
              )}
            </Section>
          </Menu>
        </NavContainer>
      </NavWrapper>
      <ContactUsModal
        isOpen={isContactModalOpen}
        onClose={() => setContactModalOpen(false)}
        triggerRef={contactButtonRef}
      />
    </>
  )
}

export default Dweb
